import { Button } from "@blueprintjs/core"
import { default as UUID } from "node-uuid"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { ID } from "src/libs/interfaces/layouts"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import { __ } from "src/libs/utilities"
import { IPETest, PETestQuestion, PETestQuestionAnswer } from "../../data/interfaces"
import { useTestsStore } from "../../data/store"
import useGenTest from "../../hooks/useGenTest"
import Answer from "./Answer"

/* Protopia Ecosystem component */ 
const MultiChoice = (props: IScalarForm): JSX.Element => {
    const {question_id} = useParams()
    const genTest: IPETest = useGenTest()
    // console.log( genTest )

    const [currentAnswer, setCurrentAnswer] = useState<PETestQuestionAnswer>({} as PETestQuestionAnswer)
    const [answers, setAnswers] = useState<PETestQuestionAnswer[]>([])

    useEffect(() => {
        const question = getQuestion()
        if( !!question ) { 
            // console.log(question)
            setAnswers( question.answers )
            if( !!question.answers?.length ) { 
                setCurrentAnswer( question.answers[0] )
            }
            else {
                setAnswers( [] )
                setCurrentAnswer({} as PETestQuestionAnswer)
            }
        }
        else {
            setAnswers( [] )
            setCurrentAnswer({} as PETestQuestionAnswer)
        }
    }, [ question_id ])

    const getQuestion = () => {
        return genTest?.questions?.find(q => q.id === question_id) || {} as PETestQuestion
    }
    const onChangeAnswer = (
        value: any, 
        field: string, 
        data: any
    ) => {
        const _answer = {
            ...currentAnswer,
            [field]: value
        }
        const _answers = [
            ...answers.map( a => {
                if(a.id === _answer.id) {
                    return _answer
                }
                return a
            })
        ]
        setCurrentAnswer( _answer )
        setAnswers( _answers )
        updateTest( _answers )
    }
    const updateTest = (_answers: PETestQuestionAnswer[]) => {
        const _questions = [
            ...genTest.questions.map(q => {
                if(q.id === question_id) {
                    const _q =  {
                        ...q,
                        answers: _answers
                    }
                    return _q
                }
                return q
            })
        ]
        //console.log( _questions )
        useTestsStore.setState({
            genTest : {
                ...genTest,
                questions: _questions
            }
        })
    }
    const onAdd = () => {
        const _answer = {
            id: UUID.v4(),
            title: `${__("Answer")} ${answers.length}`,
            post_content: "",
            is_subquestion: false,
            order: answers.length
        }
        const _answers = [
            ...answers, 
            _answer
        ]
        setAnswers(_answers)
        setCurrentAnswer( _answer )
        // console.log( _answers )
        updateTest( _answers )
    }
    const onChoose = ( _answer: PETestQuestionAnswer ) => {
        setCurrentAnswer( _answer )
    }
    const onRemove =( i:number ) => {
        const _answers = answers.filter((a, n) => i !== n)
        setAnswers( _answers )
        updateTest( _answers )
    }
    const setRight = (id: ID) => {
        const question = getQuestion()
        if(question) {
            question.right_answer_id = id
            updateTest( answers )
        }
    }
    
    return <div className="my-2 d-flex"> 
        <div className=" w_350 mr-2 pr-2">
            {
                answers.map((a:any, i) => {
                    const isRight = getQuestion()?.right_answer_id === a.id
                    const isCurr  = currentAnswer?.id === a.id
                    return <div className={`d-flex ${ isCurr ? " bg-danger  text-light" : ""}`}  key={ a.id }>
                        <Button 
                            key={a.id} 
                            minimal 
                            alignText="left"
                            icon={ isRight ? "play": "blank" }
                            className="p-1 w-100 m-1 text-overflow flex-grow-100 "
                            onClick={() => onChoose( a ) }
                        >
                            <span className={`${ isRight ? " title" : "" } ${ isCurr ? " text-light" : ""}`}>
                                { a.title }
                            </span>
                        </Button>
                        <Button 
                            minimal 
                            alignText="left" 
                            onClick={() => onRemove(i)} 
                            className="p-1 pl-2 ml-1 my-1"
                        >
                            <i className={`far fa-trash-alt ${ isRight ? "" : "" }  ${ isCurr ? " text-light" : ""}`} />
                        </Button>  
                    </div>
                })
            }
            <Button minimal alignText="left" onClick={onAdd} className="py-1 px-3 w-100">
                <div className="d-flex align-items-center small">
                    <i className="fas fa-plus mr-2" />
                    <span className="descr text-force-contrast">
                        {__("add answer")}
                    </span>
                </div> 
            </Button> 
        </div>
        <div className="flex-grow-100 w-100 pl-2">
            <Answer 
                item={currentAnswer} 
                onChange={onChangeAnswer} 
                isRight={ getQuestion()?.right_answer_id === currentAnswer.id } 
                setRight={setRight} 
            />
        </div>
    </div>
}
export default MultiChoice